import React, {Component} from 'react';
import Screen from '../modules/Screen';
import ButtonList from '../modules/ButtonList';
var Parser = require('expr-eval').Parser;

class App extends Component{
    constructor(props){
        super(props);
        this.state={
            inputField:"",
            hasDecimal: false,
        };
    }
    append = (str) => {
        var inputField = this.state.inputField;
        this.setState({inputField:inputField+str});
    }
    handleNumbers = (e) => {
    //    var val = ButtonHandler(e);
        this.append(e.target.value);
    }
    handleOperator = (e) => {
        var lastChar = (this.state.inputField.charAt(this.state.inputField.length-1));
        console.log(isNaN(lastChar));
        if(!isNaN(lastChar))
            if(e.target.value === "."){
                    if(!this.state.hasDecimal){
                        this.append(e.target.value);
                        this.setState({hasDecimal: true});
                    }
        }else{
            this.append(e.target.value);
            this.setState({hasDecimal: false});
        }
        //Check if the last character is an operator if not proceed.
    }
    handleEquals = () => {
        //Execute or evaluate the expression.
        if(this.state.inputField.length>1){
        var answer = String(Parser.evaluate(this.state.inputField));
        this.setState({inputField: answer});
        this.setState({hasDecimal:false});
        }
    }
    handleCancel = () => {
        //Reset the inputField
        this.setState({inputField:""});
        this.setState({hasDecimal:false});
        console.log("triggered");
    }
    render(){
        return (
            <div className="tc">
                <div className="pa3 f2 bg-light-gray">
                    <h1>The Calculator</h1>
                </div>
                <div className="cf-ns nl2 nr2">
                    <div className="fl-ns w-20-ns ph2">&nbsp;</div>
                    <div className="fl-ns w-60-ns ph2">
                        <Screen text={this.state.inputField} />
                        <div className="">
                            <ButtonList clicked={this.handleNumbers} operator={this.handleOperator} equal={this.handleEquals} cancel={this.handleCancel}/>
                        </div>
                    </div>
                </div>
               
            </div>
        );
    }
}

export default App;